export function apiErrorCode(error) {
    if (error && typeof error === 'object' && 'code' in error && typeof error.code === 'string')
        return error.code;
    return undefined;
}
//# sourceMappingURL=runtime.js.map